<template>
  <div style="height: 100%; overflow-y: auto; overflow-x: hidden">
    <a-tree
        v-if="treeData.length>0"
        checkable
        :tree-data="treeData"
        :defaultExpandAll="true"
        :replaceFields="{children:'children', title: 'title', key: 'key'}"
        :checkedKeys="checkedKeys"
        @check="onCheck"
        :selectable="false"
    />
  </div>
</template>

<script>

export default {
  props: {
    treeData: {
      type: Array,
      default: ()=>{
        return []
      }
    },
    checkedKeys: {
      type: Array,
      default: ()=>{
        return []
      }
    }
  },
  methods: {
    onCheck(checkedKeys, info) {
      const {checkedNodes} = info;
      this.$emit('setCheckedKeys', checkedKeys);
      if(checkedNodes.length) {
        const keys = checkedNodes.filter(v=>v.data.props.user).map(v=>v.data.props.id);
        this.$emit('setIds', keys);
      } else {
        this.$emit('setIds', []);
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
  width: 100%;
  background-color: #fff1b8;
}
/deep/ .ant-tree li .ant-tree-node-content-wrapper {
  width: 100%;
}
</style>
